module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch3"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch3.jpg",
      "width": "5%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-3"
    }
  }, [_vm._v("You sit down in an orange plastic chair. But Sam doesn’t. He starts roaming around the waiting room.")])]), _c('a', {
    attrs: {
      "id": "pg-3"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So what movie is your mom going to take us to?” Sam asks.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You shrug. “Who knows? But remember, Sam — we promised my mom we wouldn’t act "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("too")]), _vm._v(" wild here,” you warn with a grin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, yeah,” he says. Like he really cares. He wanders over to the receptionist’s desk. He picks up a glass of clear liquid that’s sitting there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It’s probably just water, but …")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey!” you cry. “Don’t drink that!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But before you can stop him, he drinks it down. Sam drains the glass in one gulp.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then he whirls around to face you.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sam! I mean it!” you moan. “We can’t fool around. This is a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("science")]), _vm._v(" lab.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He starts to answer, but suddenly his face turns white. He clutches his throat and gasps. Then the veins on his neck start to pop out. A moment later, he makes a hideous face — as if he’s turning into Dr. Jekyll and Mr. Hyde.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You freeze. Your heart pounds wildly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What did you drink?” you ask him.")])]), _c('p', {
    staticClass: "extractLetterText",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-3"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Go on to")])]), _c('a', {
    attrs: {
      "href": "#/e9780545841054_ch004"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PAGE 4")])]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d94b0094","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545841054_ch003.vue
// module id = 72
// module chunks = 0